import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HelpService } from 'src/app/core/services/help.service';

@Component({
  selector: 'app-help-panel',
  templateUrl: './help-panel.component.html',
  styleUrls: ['./help-panel.component.scss'],
  standalone: false
})
export class HelpPanelComponent {
  constructor(public helpService: HelpService, private sanitizer: DomSanitizer) {}

  get isOpen(): boolean {
    return this.helpService.panelOpen;
  }

  get panelUrl(): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.helpService.getPanelUrl());
  }

  close(): void {
    this.helpService.closePanel();
  }

  openFullGuide(): void {
    this.helpService.openHelp();
  }
}
